import gql from 'graphql-tag';

export const REACT_TO_COMMENT_MUTATION = gql`
  mutation ReactToComment($reaction: ReactionInput!) {
    reactToComment(reaction: $reaction) {
      id
      currentUserReactions
      reactionCounts {
        type
        count
      }
    }
  }
`;

export { useReactToCommentMutation } from '../gen/types';
